import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

const loader = new GLTFLoader();

const centerModel = (model: THREE.Group<THREE.Object3DEventMap>) => {
  const box = new THREE.Box3().setFromObject(model);
  const center = box.getCenter(new THREE.Vector3());

  model.position.x -= center.x;
  model.position.y -= center.y;
  model.position.z -= center.z;
};

const makeModelBBoxHelper = (model: THREE.Group<THREE.Object3DEventMap>) => {
  const boundingBox = new THREE.Box3();
  boundingBox.setFromObject(model);
  const size = new THREE.Vector3();
  boundingBox.getSize(size);
  const center = new THREE.Vector3();
  boundingBox.getCenter(center);
  const boxHelper = new THREE.Box3Helper(boundingBox, new THREE.Color(0xff0000));

  return boxHelper;
};

const initScene = (root: HTMLElement) => {
  const width = window.innerWidth;
  const height = window.innerHeight;

  const renderer = new THREE.WebGLRenderer({
    antialias: true
  });
  renderer.setSize(width, height);
  root.appendChild(renderer.domElement);

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
  const controls = new OrbitControls(camera, renderer.domElement);

  camera.position.z = 5;

  controls.update();

  // const intensity = 1;

  // const ambientlight = new THREE.AmbientLight(0xffffff, intensity / 3);
  // scene.add(ambientlight);

  // const spotlight = new THREE.SpotLight(0xffffff, intensity * 2, 0, Math.PI, 2, 0.1);
  // spotlight.castShadow = true;
  // spotlight.position.y = 200;
  // scene.add(spotlight);

  // const spotlight2 = new THREE.SpotLight(0xffffff, intensity * 2, 0, Math.PI, 2, 0.1);
  // spotlight2.castShadow = true;
  // spotlight2.position.y = -200;
  // scene.add(spotlight2);

  // const spotlightHelper = new THREE.SpotLightHelper(spotlight2, new THREE.Color(0x00ff00));
  // scene.add(spotlightHelper);

  const ambientLight = new THREE.AmbientLight(0xffffff, 0.3);

  // Key light (main light source)
  const keyLight = new THREE.DirectionalLight(0xffffff, 0.8);
  keyLight.position.set(100, 200, 100); // above and to the front-right
  keyLight.castShadow = true;

  // Fill light (softens shadows on the opposite side)
  const fillLight = new THREE.DirectionalLight(0xffffff, 0.4);
  fillLight.position.set(-100, 100, 100); // opposite side
  fillLight.castShadow = false;

  // Back light (adds rim lighting)
  const backLight = new THREE.DirectionalLight(0xffffff, 0.4);
  backLight.position.set(0, 150, -100); // behind the object
  backLight.castShadow = false;

  // Add all lights to the scene
  scene.add(ambientLight, keyLight, fillLight, backLight);

  // const pointlight = new THREE.PointLight(0xffffff, intensity);
  // scene.add(pointlight);
  // const pointlightHelper = new THREE.PointLightHelper(pointlight, 1, new THREE.Color(0x00ff00));
  // scene.add(pointlightHelper);

  loader.load('./a930.glb', gltf => {
    const model = gltf.scene;
    console.log(model);

    model.children.forEach(child => {
      child.receiveShadow = true;
      child.castShadow = true;
    });

    const skinModel = model.getObjectByName('a930_slicer_skin');
    if (skinModel && skinModel instanceof THREE.Mesh) {
      const material = skinModel.material as THREE.MeshPhysicalMaterial;
      material.opacity = 1;
      material.side = THREE.BackSide;
      skinModel.visible = false;
    }

    model.rotateX(-(Math.PI / 2));
    centerModel(model);

    scene.add(model);

    scene.add(makeModelBBoxHelper(model));

    const box = new THREE.Box3().setFromObject(model);

    const center = box.getCenter(new THREE.Vector3());
    const size = box.getSize(new THREE.Vector3());

    const distance = Math.max(size.x, size.y, size.z) * 0.8;
    camera.position.set(center.x, center.y, center.z + distance);

    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
  });

  const animate = () => {
    requestAnimationFrame(animate);

    controls.update();

    renderer.render(scene, camera);
  };
  animate();
};

export default initScene;
